import { ref } from 'vue'
import { useReducedMotion } from './useReducedMotion'

/**
 * 数字递增动画
 * @param target 目标数值
 * @param duration 动画持续时间（毫秒），默认 2000
 */
export function useCountUp(target: number, duration = 2000) {
  const count = ref(0)
  const prefersReducedMotion = useReducedMotion()

  let rafId: number | null = null
  let startTime: number | null = null

  // ease-out 缓动函数
  function easeOut(t: number): number {
    return 1 - Math.pow(1 - t, 3)
  }

  function animate(currentTime: number) {
    if (startTime === null) startTime = currentTime
    const elapsed = currentTime - startTime
    const progress = Math.min(elapsed / duration, 1)

    count.value = Math.floor(easeOut(progress) * target)

    if (progress < 1) {
      rafId = requestAnimationFrame(animate)
    } else {
      count.value = target
    }
  }

  function start() {
    if (prefersReducedMotion.value) {
      count.value = target
      return
    }
    startTime = null
    rafId = requestAnimationFrame(animate)
  }

  function stop() {
    if (rafId !== null) {
      cancelAnimationFrame(rafId)
      rafId = null
    }
  }

  return { count, start, stop }
}
